import ProductConfigurationModal from '@/features/pos/components/ProductConfigurationModal'
import { usePortal } from '@/features/pos/components/ProductConfigurationModal/contexts/Portal'
import {
    useConfigurableProductId,
    useConfigurableProductIdActions,
} from '@/features/pos/contexts/ConfigurableProductId'
import { useConfigurableProduct } from '@/features/pos/hooks/configurable-product-modal/useConfigurableProduct'
import { useConfirmProductConfiguration } from '@/features/pos/hooks/configurable-product-modal/useConfirmProductConfiguration'
import { useCloseOnPosModeChange } from '@/features/pos/hooks/useCloseOnPosModeChange'
import { useMemo } from 'react'

export const useConfigurableProductModal = (): void => {
    const productId = useConfigurableProductId()

    const product = useConfigurableProduct(productId)

    const { unset } = useConfigurableProductIdActions()

    const handleConfirm = useConfirmProductConfiguration()

    const MemoizedProductConfigurationModal = useMemo(
        () =>
            product && (
                <ProductConfigurationModal
                    key={productId}
                    allowQuantityChange
                    productName={product.name}
                    productVariants={product.productVariants}
                    onConfirm={handleConfirm}
                    onCancel={unset}
                />
            ),
        [product, productId, handleConfirm, unset]
    )

    usePortal(!!product, MemoizedProductConfigurationModal)

    useCloseOnPosModeChange(unset)
}
